<script>
  import { inventoryMethods, warehouseMethods, pendingsMethods, productsReportMethods, inventoryReportsMethods, sellersMethods } from '@state/helpers'
  import { mapGetters } from 'vuex'
  import Multiselect from "vue-multiselect";
  let _moment = require('moment')
  import { read, utils, writeFileXLSX } from 'xlsx';
  
  export default {
    name: 'TitleCountReview',
    components: {Multiselect},
    data() {
      return {
        modalShow: false,
        showEmailModal: false,
        showSellerModal:false,
        withEmail: false,
        order: {},
        sendingOrder: false,
        orderNumber: 0,
        orderOK: false,
        orderError: false,
        orderErrorMessage: '',
        sendingPendingProducts: false,
        sendingPendingProductsData: [],
        sendingProducts: false,
        sendingProductsData: [],
        sellerOptions:[],
        seller:null,
        noOrder: false,
        emails: JSON.parse(window.localStorage.getItem('emails')) || [],
        subject: 'Pedido',
        message: ''
      }
    },
    computed: {
      ...mapGetters({
        warehouse_i: 'retina/inventory/warehouse_i',
        ubication_i: 'retina/inventory/ubication_i',
        spent: 'retina/inventory/spent',
        total_spent: 'retina/inventory/total_spent',
        pending: 'retina/inventory/pending',
      }),
    },
    mounted() {
      this.subject = '(' + new Date(Date.now()).toLocaleDateString() + ') Pedido'
      this.subject += ' de ' + this.ubication_i.name
      this.message = 'Buen día,\n\nSe adjunta el pedido actual'
      this.message += this.ubication_i ? ' de la ubicación: ' + this.ubication_i.name : ''
      this.message += '\n\nCualquier duda comuníquese con su asesor comercial.\n\nPor favor no responder a este correo.'
      this.populateSellersOptions();
    },
    methods: {
      ...inventoryMethods,
      ...warehouseMethods,
      ...pendingsMethods,
      ...productsReportMethods,
      ...inventoryReportsMethods,
      ...sellersMethods,
      populateSellersOptions() {
        const promise = this.fetchOptionsSellers();
        return promise
          .then((data) => {
            let listOptions = [];
            data.forEach((opt) => {
              listOptions.push({
                value: opt.nit,
                text: `${opt.code}-${opt.name}`
              });
            });
            this.sellerOptions = listOptions;
          })
          .catch((error) => {
            this.$axios_error_noty(error, this);
          });
      },
      toggleReadonly(event) {
        if (event.target.getAttribute("readonly") == "readonly") {
          event.target.removeAttribute("readonly");
        }
      },
      labelOfOption(opt, options) {
        let optionFound = options.find((x) => x.value === opt);
        let optionsCache = [];
        if (!optionFound) {
          let cacheFound = optionsCache.find((x) => x.value === opt);
          return cacheFound ? cacheFound.text : false ? `${opt}` : "";
        } else {
          return optionFound.text;
        }
      },
      validator(tag) {
        let exr = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
        let validEmail = exr.test(tag)
        // const required = (val) => val && val.length;
        return validEmail
      },
      goToCountSpentProducts() {
        this.disableInventoryCountReview()
        this.enableInventoryCountSpentProducts()
      },
      /* -- create pendings -- */
      async createProducts() {
        this.pending.map( async (product) => {
          const response = await this.createProduct(product).then((data) => {
            this.sendingProductsData.push(data)
            // Mirar Promise.allSettled().then() ...
          }).catch(error => {
            console.log(error)
          })
          return response
        })
      },
      async createInventoryReference() {
        let id, ubications, nit, name, multi_ubication, company, id_price, pay_condition, subsidiary, w, l
        ;({ id, name, multi_ubication, ubications, company, nit, ...w } = this.warehouse_i)
          w['id_warehouse'] = id
          w['multi_location'] = ubications.length > 0 ? true : false
  
        if (Boolean(this.ubication_i)) {
          ;({ id, name, id_price, pay_condition, subsidiary, ...l } = this.ubication_i)
          l['id_location'] = id
          l['location_name'] = name
        } else {
          l = {}
          l['id_location'] = null
          l['nit'] = null
          l['location_name'] = null
        }
        let inventoryReference = {}
        Object.assign(inventoryReference, w, l)
  
        await this.createInventory(inventoryReference).then((data) =>{
          return true
        }).catch((error) => {
          this.$generate_toast(this, 'error', 'Error creando referencia de inventario: '+error)
          return error
        })
  
      },
      async createPendings() {
        let id_warehouse, id_location
        id_warehouse = this.warehouse_i.id
        if (Boolean(this.ubication_i)) {
          id_location = this.ubication_i.id
        } else {
          id_location = null
        }
  
        this.pending.map(async (product) => {
          let pendingProduct = {}
          Object.assign(pendingProduct,{id_warehouse, id_location}, product)
          const response = await this.createPending(pendingProduct).then((data) => {
            this.sendingPendingProductsData.push(data)
          })
          return response
        })
      },
      /* ------- */
      async sendPendingProducts() {      
        /*
        borrar pendientes de base de datos (pendientes pasados)
        enviar productos (crear referencia)
        enviar inventario (crear referencia warehouse, location)
        enviar pendientes (pendientes actuales)
        proseguir con la orden
        */
        await this.deleteAllPendings(
          '?id_warehouse=' + this.warehouse_i.id +
          '&id_location=' + ( this.ubication_i && this.ubication_i.id || '')
          )
        if(this.pending.length > 0) {
          this.sendingPendingProductsData = []
          this.sendingProductsData = []
          this.sendingProducts = true
          await this.createProducts()
          this.sendingProducts = false
          this.sendingPendingProducts = true
          if (await this.createInventoryReference()){
            this.$generate_toast(this, 'error', 'Hubo un error, no se puede continuar')
            return false
          } else  {
            await this.createPendings()
            this.sendingPendingProducts = false
          }
        }
      },
  
      exportFile() {
        const data = this.generateXLSContent()
        var domParser = new DOMParser();
        const wb = utils.table_to_book(domParser.parseFromString(data,"text/html"))
        writeFileXLSX(wb, `pedido-${(new Date).toISOString().split('T')[0]}.xlsx`);
      },
  
      generateXLSContent() {
        let data = this.spent
        let htmlRows = [];
        data.forEach((item) => {
          for (let j = 0; j < item.batchs.length; j++) {
            for (let i = 0; i < item.batchs[j].assurance.length; i++) {
              const assurance = item.batchs[j].assurance[i] || item.batchs[j].assurance[0];
              const batch = item.batchs[j].batch;
              const serial = item.batchs[j].serials[i];
              let row = `
                <tr>
                  <td data-t="s">${item && item.name ? item.name : item && item.reference ? item.reference : '-no-encontrado-' }</td>
                  <td data-t="s">${item.id_ext1}</td>
                  <td>${batch}</td>
                  <td>${serial}</td>
                  <td>${assurance}</td>
                </tr>
              `;
              htmlRows.push(row);
            }
          }
        });
  
        const htmlContent = `<table>
                <thead>
                  <tr>
                    <th>Cliente:</th>
                    <th colspan=4>${this.warehouse_i.description}</th>
                  </tr>
                  <tr>
                    <th>Ubicaci&oacute;n:</th>
                    <th colspan=4>${this.ubication_i && this.ubication_i.name ? this.ubication_i.name : '-no-encontrada-'}</th>
                  </tr>
                  <tr>
                    <th>Fecha:</th>
                    <th colspan=4>${_moment(new Date()).format('YYYY-MM-D hh:mm:ss a')}</th>
                  </tr>
                  <tr>
                    <th colspan=5>&nbsp;</th>
                  </tr>
                  <tr>
                    <th>Producto</th>
                    <th>Extensión</th>
                    <th>Lote</th>
                    <th>Serial</th>
                    <th>Vencimiento</th>
                  </tr>
                </thead>
                <tbody>
                  ${htmlRows.join('')}
                </tbody>
              </table>
        `;
  
        return htmlContent;
      },
  
      async errorToMessage(error){
        if (error.response && error.response.status === 502 && "data" in error.response){
          let description = error.response.data.description
          let params = error.response.data.params
          let params_errors = ""
          for (let param = 0; param < params.length; param++) {
            params_errors += "- " + params[param].value + ": " + params[param].detail + "<br>";
          }
          this.orderErrorMessage = `<b>${description}:</b><br>${params_errors}`
        } else {
          this.orderErrorMessage = error
        }
      },
  
      async proccessSendOrder() {
        console.info("start proccessSendOrder()")
        this.orderOK = false
        this.orderError = false
        this.sendingOrder = true
        this.modalShow = true
        this.orderErrorMessage = ''
  
        // definición del nuevo objecto para envío de email de los resultados del conteo:
        let email_data = {}
        if(this.emails.length > 0){
          email_data = {
            To_emails: this.emails,
            subject: this.subject,
            message: this.message,
            warehouse: this.warehouse_i.description,
          }
          window.localStorage.setItem('emails', JSON.stringify(this.emails))
          this.showEmailModal = false
        } else email_data = null
        if(this.seller != null)this.showSellerModal = false
        else {
          this.sendingOrder = false
          this.modalShow = false
          this.$generate_toast(this, 'info', 'No se crea Pedido debido a que no ha seleccionado un vendedor')
          return false
        }
        console.info("mails.length? ", this.emails.length)
  
        try {
          console.info("before sendPendingProducts()")
          await this.sendPendingProducts()
          console.log("passed sendPendingProducts()")
        } catch(error){
          console.error("Error on sendPendingProducts()", error)
          this.$generate_toast(this, 'error', 'Ocurrió un error preparando la orden, reintente nuevamente')
          this.orderError = true
          this.sendingOrder = false
          await this.errorToMessage(error)
          return 
        }
  
        if(this.spent.length == 0) {
          this.noOrder = true
          this.sendingOrder = false
          this.orderError = false
          this.orderErrorMessage = ''
          this.modalShow = false
          this.$generate_toast(this, 'info', 'No se crea Pedido debido a que no hay productos consumidos')
          return
        }
  
        this.order = {}
        this.order.order_uuid = 'c8da3bfe-40cc-451c-b2b4-00958dacef37' // ! hace referencia al uuid del conector de ordenes en base de datos ... uuid -> unico
        this.order.commitment_uuid = '8bf47cc4-6b83-4a60-a758-0967bb7d1fc6' // ! hace referencia al uuid del conector de compromisos en base de datos ... uuid -> unico
        this.order.nit = this.ubication_i.nit
        this.order.id_co = '001'
        this.order.subsidiary = this.ubication_i.subsidiary
        this.order.warehouse = this.warehouse_i.code
        this.order.location = this.ubication_i.id
        this.order.pay_condition = this.ubication_i.pay_condition
        this.order.id_price = this.ubication_i.id_price
        this.order.items = this.spent
        this.order.email = email_data
        this.order.seller = this.seller
  
        console.log("before sendOrder(). Keys: ", Object.keys(this.order).length, 'Items:', this.order.items.length)
        this.sendOrder(this.order)
          .then(async(data) => {
            console.log("sendOrder.then(data)", data)
            this.sendingOrder = false
            this.orderNumber = data
            this.orderOK = true
            this.orderErrorMessage = null
          })
          .catch(async(error) => {
            console.error("sendOrder.catch(error)", error)
            this.orderNumber = null
            this.sendingOrder = false
            this.orderError = true
            await this.errorToMessage(error)
            if (this.emails.length === 0){
              this.orderErrorMessage += '<br><br><b>Te recomendamos que finalices enviando el resultado del pedido por email</b>'
            }
          })
      },
      reset() {
        this.clearInventory()
        this.setStock([])
        this.clearSpent()
        this.clearPending()
        this.setTotalPending(0)
        this.disableInventoryCountMode()
        this.setInventoryOnlineMode(false)
        this.setInventoryCountReview(false)
        this.setConsultWarehouse(true)
      },
    },
  }
  </script>
  <template>
    <b-card no-body class="p-2">
      <!-- orderNumber: {{orderNumber.data.order}} -->
      <span class="text-primary font-weight-lighter">Lugar seleccionado:</span>
      <b-card-title>{{ warehouse_i.description }}</b-card-title>
      <b-card-sub-title class="mb-2 lead">
        {{ ubication_i ? ubication_i.name : '' }}
        <b-badge variant="primary">{{ warehouse_i.code }}</b-badge>
      </b-card-sub-title>
      <b-card-footer footer-bg-variant="transparent" footer-class="p-0 d-flex justify-content-between">
        <b-button-group class="w-100">
          <b-button
            v-if="(!orderOK&&!noOrder)"
            @click="goToCountSpentProducts()"
            variant="outline-secondary"
            class="mr-1"
          >
            <i class="fas fa-chevron-left"></i>{{ ' ' }}
            <i class="fas fa-box-open"></i>
            Consumidos
          </b-button>
          <!-- <b-button
            @click="proccessSendOrder()"
            v-if="(!orderOK&&!noOrder)"
            variant="outline-success"
            class="mr-1"
          >
            Finalizar inventario 
            <b-checkbox v-model="withEmail" switch inline class="m-0" />          
          </b-button> -->
  
          <b-dropdown 
            v-if="(!orderOK&&!noOrder)" 
            no-caret variant="outline-success" 
            class="btn p-0 m-0 mr-1"  >
            <template #button-content>
              Finalizar inventario <i class="fas fa-share ml-1"></i>
            </template>
            <b-dropdown-item @click="showEmailModal = true" :disabled="sendingOrder">Enviar con email <i class="fas fa-envelope ml-1"></i></b-dropdown-item>
            <b-dropdown-item @click="showSellerModal = true" :disabled="sendingOrder">Enviar sin email <i class="fas fa-share ml-1"></i></b-dropdown-item>
            <b-dropdown-item v-if="spent.length > 0" @click="exportFile()" :disabled="sendingOrder">Descargar Excel <i class="fas fa-file-excel ml-1"></i></b-dropdown-item>
          </b-dropdown>
  
            <b-button v-if="orderNumber && 'data' in orderNumber && 'order' in orderNumber.data" variant="link" disabled class="mr-1 d-inline text-primary">
              Número de pedido: {{ orderNumber.data.order }}
            </b-button>
            <b-button v-if="noOrder" variant="link" disabled class="mr-1 d-inline text-primary">
              No se envía Pedido
            </b-button>
            <b-button v-if="orderOK||noOrder" @click="reset()" variant="outline-info" class="d-inline">
              Terminar <i class="fas fa-check ml-1"></i>
            </b-button>
        </b-button-group>
       </b-card-footer>
  
      <b-modal
        v-model="showEmailModal"
        hide-footer
        id="email"
        size="xl"
        title="Enviar Resultado por Correo"
      >
        <!-- <div class="d-flex w-100 justify-content-between col-xl-6"> -->
        <div class="d-flex">
          <div class="col-12 col-md-6">
            <b-form-group
              class="mt-2"
              id="fieldset-horizontal"
              label-cols-sm="2"
              label-cols-lg="2"
              content-cols-sm
              content-cols-lg="9"
              label="Correos:"
              label-for="input-horizontal"
            >
              <b-form-tags
                placeholder="Agregar correo..."
                input-id="tags-state-event"
                tag-variant="light"
                tag-pills
                size="md"
                v-model="emails"
                :tag-validator="validator"
                add-button-text="Agregar"
                add-button-variant="primary"
                invalid-tag-text="Correo inválido"
                :separator="[',', ' ',';']"
              >
              <!-- @tag-state="onTagState" -->
              </b-form-tags>
            </b-form-group>
    
            <b-form-group
              class="mt-2"
              id="fieldset-horizontal"
              label-cols-sm="2"
              label-cols-lg="2"
              content-cols-sm
              content-cols-lg="9"
              label="Asunto:"
              label-for="input-horizontal"
            >
              <b-form-input v-model="subject" id="input-horizontal"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-12 col-md-6">
            <b-form-group
              class="mt-2"
              id="fieldset-horizontal"
              label-cols-sm="2"
              label-cols-lg="2"
              content-cols-sm
              content-cols-lg="9"
              label="Vendedor:"
              label-for="input-horizontal"
            >
              <template>
                <Multiselect
                  @focus="toggleReadonly"
                  :options="sellerOptions.map((client) => client.value)"
                  :custom-label="(opt) => labelOfOption(opt, sellerOptions)"
                  v-model="seller"
                  :loading="sellerOptions.length==0"
                  placeholder="Elije el vendedor"
                >
                </Multiselect>
              </template>
            </b-form-group>
          </div>
        </div>
        
  
        <div>
          <b-form-textarea
            v-model="message"
            id="textarea-no-resize"
            placeholder="Mensaje"
            rows="10"
            no-resize
          ></b-form-textarea>
        </div>
  
        <b-button @click="proccessSendOrder()" :disabled="emails.length === 0 || seller==null" class="mt-2" variant="success">
          <i class="fas fa-mail-bulk"></i> Finalizar y enviar
        </b-button>
      </b-modal>
      <b-modal
        v-model="showSellerModal"
        hide-footer
        size="xl"
        title="Enviar Resultado sin email"
      >
        <!-- <div class="d-flex w-100 justify-content-between col-xl-6"> -->
        <div class="d-flex">
          <div class="col-12 col-md-6">
            <b-form-group
              class="mt-2"
              id="fieldset-horizontal"
              label-cols-sm="2"
              label-cols-lg="2"
              content-cols-sm
              content-cols-lg="9"
              label="Vendedor:"
              label-for="input-horizontal"
            >
              <template>
                <Multiselect
                  @focus="toggleReadonly"
                  :options="sellerOptions.map((client) => client.value)"
                  :custom-label="(opt) => labelOfOption(opt, sellerOptions)"
                  v-model="seller"
                  :loading="sellerOptions.length==0"
                  placeholder="Elije el vendedor"
                >
                </Multiselect>
              </template>
            </b-form-group>
          </div>
        </div>
        <b-button @click="proccessSendOrder()" :disabled="seller==null" class="mt-2" variant="success">
          <i class="fas fa-mail-bulk"></i> Finalizar y enviar
        </b-button>
      </b-modal>
      <b-modal
        ok-only
        hide-header
        no-close-on-backdrop
        no-close-on-esc
        ok-title="Cerrar"
        ok-variant="secondary"
        size="lg"
        :busy="sendingOrder"
        v-model="modalShow"
      >
        <!-- <pre>{{order}}</pre> -->
        <!-- v-if="sendingOrder" -->
        <div
          v-if="sendingProducts && sendingProductsData.length > 0"
          class="row d-flex justify-content-center align-items-center"
        >
          <b-spinner variant="primary mr-1"></b-spinner>
          <h4>{{sendingProductsData}}</h4>
        </div>
        <div
          v-if="sendingPendingProducts && sendingPendingProductsData.length > 0"
          class="row d-flex justify-content-center align-items-center"
        >
          <b-spinner variant="primary mr-1"></b-spinner>
          <h4>{{sendingPendingProductsData}}</h4>
        </div>
        <div
          v-if="sendingOrder"
          class="row d-flex justify-content-center align-items-center"
        >
          <b-spinner variant="primary mr-1"></b-spinner>
          <h4>Realizando pedido...</h4>
          <div style="width: 100%; max-height: 40px; overflow-y: auto; font-size: 10px; color: gray;">
            {{ logSendingOrder }}
          </div>
        </div>
        <!--  -->
        <div v-else>
          <div v-if="orderNumber && 'data' in orderNumber && 'order' in orderNumber.data">
            <!--  -->
            <div class="row d-flex justify-content-center">
              <h4 class="mr-1">
                Pedido realizado <i class="fas fa-check-circle text-success"></i>
              </h4>
              <h4 class="mr-1">Número de pedido:</h4>
              <h4 v-if="orderNumber">{{ orderNumber.data.order }}</h4>
            </div>
          </div>
          <div v-if="orderNumber && 'data' in orderNumber && 'message' in orderNumber.data">
            <!--  -->
            <div class="row d-flex justify-content-center">
              <h4 class="mr-1">
                Envío realizado <i class="fas fa-check-circle text-warning"></i>
              </h4>
              <h4 class="mr-1">Mensaje del servidor:</h4>
              <h4>{{ orderNumber.data.message }}</h4>
            </div>
          </div>
          <div v-if="orderError">
            <!--   -->
            <div class="row d-flex justify-content-center">
              <h4 class="mr-1">
                Pedido no realizado
                <i class="fas fa-times-circle text-danger"></i>
              </h4>
              <!-- <h4 class="mr-1">Error:</h4> -->
            </div>
              <p v-if="orderError" v-html="orderErrorMessage" ></p>
            <div>
              <!-- <b-button
                :disabled="orderOK"
                @click="proccessSendOrder()"
                variant="primary"
              >
                <i class="far fa-share-square mr-1"></i> Re-enviar
              </b-button> -->
              <b-dropdown 
                v-if="(!orderOK&&!noOrder)" 
                no-caret variant="primary" 
                class="btn p-0 m-0 mr-1"  >
                <template #button-content>
                  Enviar nuevamente <i class="fas fa-share ml-1"></i>
                </template>
                <b-dropdown-item @click="showEmailModal = true" :disabled="sendingOrder || orderOK">Enviar con email <i class="fas fa-envelope ml-1"></i></b-dropdown-item>
                <b-dropdown-item @click="proccessSendOrder()" :disabled="sendingOrder || orderOK">Enviar sin email <i class="fas fa-share ml-1"></i></b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
      </b-modal>
    </b-card>
  </template>
  